import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../../../constants/componentTypes";
import * as navigationActions from "../../../../../actions/navigationActions";
import * as orderActions from "../../../../../actions/intergammaOrderActions";

class ConfirmCustomerModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchResetLastCustomerAction();
        this.props.dispatchCloseModalAction();
    };

    getCustomer = () => {
        if (
            this.props.params === undefined ||
            this.props.params.customer === undefined ||
            this.props.params.customer === null
        ) {
            return null;
        }

        return this.props.params.customer;
    };

    handleButtonClick = () => {
        this.props.dispatchSetLastCustomerAction(this.getCustomer());
    };

    getCustomerName = () => {
        let customer = this.getCustomer();

        if (customer === null) {
            return "";
        }

        return customer.name;
    };

    render() {
        return (
            <div id="modal" className="default-modal ig-restart-modal ig-small-modal">
                <div className="modal-content">
                    <div className="col-xs-12 ">
                        <Translate value="customRedlike.useCustomerInOrder" customerName={this.getCustomerName()} />
                    </div>
                    <div className="modal-footer">
                        <div className="col-xs-6 text-right">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleCloseModalClick}>
                                <span className="glyphicon glyphicon-menu-right" />
                                <Translate value="general.no" />
                            </button>
                        </div>
                        <div className="col-xs-6 text-left ">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleButtonClick}>
                                <span className="glyphicon glyphicon-menu-right" />
                                <Translate value="general.yes" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.INTERGAMMA_CONFIRM_CUSTOMER_MODAL));
        },
        dispatchSetLastCustomerAction: (customer) => {
            dispatch(orderActions.setLastCustomer(customer));
        },
        dispatchResetLastCustomerAction: () => {
            dispatch(orderActions.resetLastCustomer());
        }
    };
};

export default ConfirmCustomerModal = connect(mapStoreToProps, mapDispatchToProps)(ConfirmCustomerModal);
